import { render } from "./IntegrationIndicators.vue?vue&type=template&id=ac5c7fca&scoped=true"
import script from "./IntegrationIndicators.vue?vue&type=script&lang=js"
export * from "./IntegrationIndicators.vue?vue&type=script&lang=js"

import "./IntegrationIndicators.vue?vue&type=style&index=0&id=ac5c7fca&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac5c7fca"]])

export default __exports__